export default "__VITE_ASSET__c072942b__"